import { useState, useEffect, useCallback } from 'react';
import { bannerAnime } from '@/mocks/anime';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % bannerAnime.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const item = bannerAnime[current];

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={item.cover}
          alt={item.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 h-full flex items-center">
        <div className="w-full flex flex-col items-center text-center pt-16">
          <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 leading-tight">
            51动漫网
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-2 max-w-2xl">
            免费好看的动漫在线阅读大全 —— 日漫、国漫、韩漫，尽在掌握
          </p>
          <p className="text-sm text-background-300/80 mb-8 max-w-xl hidden sm:block">
            51动漫网站 | 51动漫官网 | 51动漫官方网站 —— 您的随身动漫追更平台
          </p>

          <div className="flex items-center gap-3 mb-8">
            <a
              href="#category-nav"
              className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即浏览
            </a>
            <a
              href="#hot-recommend"
              className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </a>
          </div>

          <div className="flex items-center gap-2">
            {bannerAnime.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                  idx === current
                    ? 'bg-primary-500 w-6'
                    : 'bg-background-50/40 hover:bg-background-50/60'
                }`}
                aria-label={`切换到第${idx + 1}张`}
              />
            ))}
          </div>

          <div className="mt-10 bg-background-50/10 backdrop-blur-md rounded-2xl px-6 py-4 inline-block">
            <div className="flex items-center gap-4">
              <img
                src={item.cover}
                alt={item.title}
                className="w-14 h-18 md:w-16 md:h-20 rounded-lg object-cover object-top shrink-0"
              />
              <div className="text-left">
                <p className="text-background-50 font-heading text-sm md:text-base">{item.title}</p>
                <p className="text-background-300/80 text-xs mt-1">
                  {item.status} · {item.updateChapter} · 评分 {item.rating}
                </p>
                <div className="flex gap-1 mt-1">
                  {item.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="text-xs px-2 py-0.5 bg-background-50/15 rounded-full text-background-200/80 whitespace-nowrap">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}